// src/api/user.js
export async function fetchUser(token) {
  // ✅ 1. Guard against missing token
  if (!token) {
    throw new Error("Missing access token");
  }

  // ✅ 2. Make the request
  const res = await fetch("https://api.kloudscan.com/user", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    cache: "no-store", // ✅ prevent browser caching
  });

  // ✅ 3. Gracefully handle known statuses
  if (res.status === 404) {
    // no record yet, return null to prevent React Query from retrying forever
    return null;
  }

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `fetchUser failed: ${res.status} ${text || res.statusText}`
    );
  }

  // ✅ 4. Parse and return JSON safely
  const data = await res.json().catch(() => ({}));
  return data;
}
